import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Text from 'components/Text';

import '../Button/button.styles.scss';

export default class ButtonLink extends React.Component {
    render() {
        const { to, theme, text, className, ...rest } = this.props; // eslint-disable-line no-unused-vars

        const themeClass = theme || 'primary';
        const classes = 'button button--' + themeClass + ' ' + (className ? className : '');

        if (typeof to === 'string' && to.match(/^http[s]?:\/\//)) {
            return (
                <a
                    className={classes}
                    href={to}
                    role="button"
                    {...rest}
                >
                    <Text textKey={text} />
                </a>
            );
        }

        return (
            <Link
                className={classes}
                to={to}
                role="button"
                {...rest}
            >
                <Text textKey={text} />
            </Link>
        );
    }
}

ButtonLink.propTypes = {
    to: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
    ]).isRequired,
    theme: PropTypes.string,
    className: PropTypes.string,
    text: PropTypes.string.isRequired,
};
